import { useSelector } from 'react-redux';
import { AutolistUser } from 'types/User';
import { getUser } from 'redux-implementations/selectors';

export const useAutolistUser = (): Partial<AutolistUser> => {
  return useSelector(getUser);
};
